/**
 * An id -> name map whose `get` returns `fallback` for an unknown id.
 *
 * Name lookups render `map.get(id) ?? id`. When the session cannot read the
 * employee list (issue #1670), a page passes this map so every lookup shows
 * the "Not available for your role" hint instead of a raw id.
 */
export class NameMapWithFallback extends Map<string, string> {
  private readonly fallback: string;

  constructor(fallback: string) {
    super();
    this.fallback = fallback;
  }

  override get(key: string): string {
    return super.get(key) ?? this.fallback;
  }
}
